import styled from 'styled-components';

import { TextButton } from '@zillow/constellation';

export const StyledDownloadButton = styled(TextButton)`
    cursor: pointer;
`;
